<div mat-dialog-content class="signed-files-modal">
  <div class="success-banner">
    <div class="success-banner-inner">
      <div class="success-banner-icon-wrap" aria-hidden="true">
        <i class="fas fa-check success-banner-icon"></i>
      </div>
      <div class="success-banner-copy">
        <h2 class="success-banner-title" tabindex="-1" cdkFocusInitial>Documentos firmados</h2>
        <p class="success-banner-subtitle">La firma se completó correctamente. Revisa, descarga o envía tus archivos.</p>
      </div>
    </div>
    <button
      class="success-banner-close"
      (click)="closeDialog()"
      type="button"
      [disabled]="sendingEmail"
      [attr.aria-disabled]="sendingEmail"
      aria-label="Cerrar modal">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <div class="dialog-body">
    <div class="files-overview">
      <div class="overview-item">
        <span class="overview-label">Documentos</span>
        <strong class="overview-value">{{ data.signedFileSrcs.length }}</strong>
      </div>
      <div class="overview-item">
        <span class="overview-label">Seleccionados</span>
        <strong class="overview-value">{{ selectedCount }}</strong>
      </div>
      <div class="overview-item">
        <span class="overview-label">Formato</span>
        <strong class="overview-value">{{ getFileTypeLabel(data.fileType) }}</strong>
      </div>
    </div>

    <div class="summary-table">
      <div class="table-scroll-wrapper">
        <table class="signature-summary">
          <thead>
            <tr>
              <th class="check-col">
                <input
                  type="checkbox"
                  class="row-check"
                  [checked]="allSelected"
                  [indeterminate]="selectedCount > 0 && !allSelected"
                  (change)="toggleSelectAll($event)"
                  aria-label="Seleccionar todos" />
              </th>
              <th>#</th>
              <th>Nombre del Archivo</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let fileName of data.originalFileNames; let i = index"
              class="signature-row"
              [class.is-selected]="isSelected(i)"
              (click)="toggleRow(i)">
              <td class="check-cell" data-label="Seleccionar" (click)="$event.stopPropagation()">
                <input
                  type="checkbox"
                  class="row-check"
                  [checked]="isSelected(i)"
                  (change)="toggleRow(i, $event)"
                  [attr.aria-label]="'Seleccionar ' + fileName" />
              </td>
              <td class="index-cell" data-label="#">
                {{ i + 1 }}
              </td>
              <td class="file-name-cell" data-label="Nombre del Archivo">
                <div class="file-name-wrapper">
                  <span class="file-icon-small">{{ getFileIcon(data.fileType) }}</span>
                  <span class="file-name-text">{{ fileName }}</span>
                </div>
              </td>
              <td data-label="Estado">
                <span class="validation-badge valid">
                  <i class="fas fa-check-circle"></i>
                  Firmado
                </span>
              </td>
              <td data-label="Acciones" (click)="$event.stopPropagation()">
                <div class="file-actions-cell">
                  <button
                    *ngIf="data.fileType === 'pdf'"
                    class="btn-action btn-view"
                    (click)="viewPdf(i)"
                    [disabled]="sendingEmail"
                    title="Ver documento"
                    aria-label="Ver documento">
                    <i class="fas fa-eye"></i>
                  </button>
                  <button
                    class="btn-action btn-download"
                    (click)="downloadRow(i)"
                    [disabled]="sendingEmail"
                    title="Descargar documento"
                    aria-label="Descargar documento">
                    <i class="fas fa-download"></i>
                  </button>
                  <button
                    *ngIf="canSendFileByEmail(i)"
                    class="btn-action btn-send"
                    (click)="openSendEmailForm(i)"
                    [disabled]="sendingEmail"
                    title="Enviar documento por correo"
                    aria-label="Enviar documento por correo">
                    <i class="fas fa-envelope"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="global-actions">
      <div class="actions-buttons">
        <div class="functional-buttons">
          <button
            *ngIf="data.fileType === 'pdf'"
            type="button"
            class="btn btn-secondary"
            (click)="viewSelected()"
            [disabled]="sendingEmail"
            title="Ver el documento seleccionado">
            Ver
          </button>
          <button
            type="button"
            class="btn btn-primary"
            (click)="downloadSelected()"
            [disabled]="sendingEmail"
            title="Descargar documentos seleccionados">
            {{ downloadButtonLabel }}
          </button>
          <button
            *ngIf="showEmailActions"
            type="button"
            class="btn btn-secondary btn-send-email"
            (click)="toggleSendEmailForm()"
            [disabled]="sendingEmail"
            [attr.aria-expanded]="showSendEmailForm"
            title="Enviar documento por correo (máx. 5 MB)">
            <i class="fas fa-envelope" aria-hidden="true"></i>
            {{ showSendEmailForm ? 'Cancelar envío' : 'Enviar documento' }}
          </button>
        </div>
      </div>

      <div class="send-email-form" *ngIf="showSendEmailForm">
        <span class="send-email-label">Envío por correo</span>
        <p class="send-email-hint">{{ getSendTargetLabel() }}</p>
        <div class="send-email-row">
          <input
            id="signed-files-recipient-email"
            type="email"
            class="send-email-input"
            name="recipientEmail"
            [(ngModel)]="recipientEmail"
            placeholder="Correo del destinatario"
            autocomplete="email"
            aria-label="Correo del destinatario"
            aria-required="true"
            [disabled]="sendingEmail"
            (keyup.enter)="sendDocument()" />
          <button
            type="button"
            class="btn btn-primary send-email-submit"
            (click)="sendDocument()"
            [disabled]="!canSendEmail()"
            [attr.aria-busy]="sendingEmail"
            title="Enviar">
            {{ sendingEmail ? 'Enviando…' : 'Enviar' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
